import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { FuncionarioService } from "./funcionario.service";
import { FuncionarioApiService } from "./funcionario-api.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    FuncionarioApiService,
    FuncionarioService
  ],
  declarations: []
})
export class FuncionariosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/funcionarios/funcionarios.module.ts
 **/